import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { AssessmentResult } from '../entities/AssessmentResult'

@InputType()
export class CalculateScoresArgs extends ActionArgs {
  @Field(() => ID)
  resultId: string
}

export interface ICalculateScores extends IAction<AssessmentResult, CalculateScoresArgs> {}
